/* eslint-disable max-lines */
/* eslint-disable react/no-unknown-property */
/* eslint-disable react/no-unescaped-entities */
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import Field from 'Component/Field';
import Link from 'Component/Link';
import Popup from 'Component/Popup';

import { STYLEGUIDE_POPUP } from './StyleGuide.config';

import './StyleGuide.style';

/** @namespace Scandipwa/Route/StyleGuide/Component */
export class StyleGuideComponent extends PureComponent {
    static propTypes = {
        ...this.props,
        showPopup: PropTypes.func.isRequired,
        toggleOverlayByKey: PropTypes.func.isRequired
    };

    renderColorsBlock() {
        return (
            <div
              block="StyleGuide"
              elem="Colors"
            >
                <h3>{ __('Colors') }</h3>
                <div
                  block="StyleGuide"
                  elem="ColorsWrapper"
                >
                    <div
                      block="StyleGuide"
                      elem="ColorItem"
                    >
                        <h4>--color-black</h4>
                        <div block="StyleGuide" elem="ColorBlock" mods={ { color: 'black' } } />
                    </div>
                    <div
                      block="StyleGuide"
                      elem="ColorItem"
                    >
                        <h4>--color-white</h4>
                        <div block="StyleGuide" elem="ColorBlock" mods={ { color: 'white' } } />
                    </div>
                    <div
                      block="StyleGuide"
                      elem="ColorItem"
                    >
                        <h4>--color-gray-nero</h4>
                        <div block="StyleGuide" elem="ColorBlock" mods={ { color: 'gray-nero' } } />
                    </div>
                    <div
                      block="StyleGuide"
                      elem="ColorItem"
                    >
                        <h4>--color-gray-title</h4>
                        <div block="StyleGuide" elem="ColorBlock" mods={ { color: 'gray-title' } } />
                    </div>
                    <div
                      block="StyleGuide"
                      elem="ColorItem"
                    >
                        <h4>--color-gray-text</h4>
                        <div block="StyleGuide" elem="ColorBlock" mods={ { color: 'gray-text' } } />
                    </div>
                    <div
                      block="StyleGuide"
                      elem="ColorItem"
                    >
                        <h4>--color-gray-button</h4>
                        <div block="StyleGuide" elem="ColorBlock" mods={ { color: 'gray-button' } } />
                    </div>
                    <div
                      block="StyleGuide"
                      elem="ColorItem"
                    >
                        <h4>--color-gray-disabled</h4>
                        <div block="StyleGuide" elem="ColorBlock" mods={ { color: 'gray-disabled' } } />
                    </div>
                    <div
                      block="StyleGuide"
                      elem="ColorItem"
                    >
                        <h4>--color-gray-mortar</h4>
                        <div block="StyleGuide" elem="ColorBlock" mods={ { color: 'gray-mortar' } } />
                    </div>
                    <div
                      block="StyleGuide"
                      elem="ColorItem"
                    >
                        <h4>--color-silver</h4>
                        <div block="StyleGuide" elem="ColorBlock" mods={ { color: 'silver' } } />
                    </div>
                    <div
                      block="StyleGuide"
                      elem="ColorItem"
                    >
                        <h4>--color-input-border</h4>
                        <div block="StyleGuide" elem="ColorBlock" mods={ { color: 'input-border' } } />
                    </div>
                    <div
                      block="StyleGuide"
                      elem="ColorItem"
                    >
                        <h4>--color-input-label</h4>
                        <div block="StyleGuide" elem="ColorBlock" mods={ { color: 'input-label' } } />
                    </div>
                    <div
                      block="StyleGuide"
                      elem="ColorItem"
                    >
                        <h4>--color-brown-mongoose</h4>
                        <div block="StyleGuide" elem="ColorBlock" mods={ { color: 'brown-mongoose' } } />
                    </div>
                    <div
                      block="StyleGuide"
                      elem="ColorItem"
                    >
                        <h4>--color-brown-mongoose-light</h4>
                        <div block="StyleGuide" elem="ColorBlock" mods={ { color: 'brown-mongoose-light' } } />
                    </div>
                    <div
                      block="StyleGuide"
                      elem="ColorItem"
                    >
                        <h4>--color-orange-jaffa</h4>
                        <div block="StyleGuide" elem="ColorBlock" mods={ { color: 'orange-jaffa' } } />
                    </div>
                    <div
                      block="StyleGuide"
                      elem="ColorItem"
                    >
                        <h4>--color-pink-rose</h4>
                        <div block="StyleGuide" elem="ColorBlock" mods={ { color: 'pink-rose' } } />
                    </div>
                    <div
                      block="StyleGuide"
                      elem="ColorItem"
                    >
                        <h4>--color-red</h4>
                        <div block="StyleGuide" elem="ColorBlock" mods={ { color: 'red' } } />
                    </div>
                    <div
                      block="StyleGuide"
                      elem="ColorItem"
                    >
                        <h4>--color-red-dark</h4>
                        <div block="StyleGuide" elem="ColorBlock" mods={ { color: 'red-dark' } } />
                    </div>
                    <div
                      block="StyleGuide"
                      elem="ColorItem"
                    >
                        <h4>--color-red-cardinal</h4>
                        <div block="StyleGuide" elem="ColorBlock" mods={ { color: 'red-cardinal' } } />
                    </div>
                </div>
            </div>
        );
    }

    renderFontsBlock() {
        return (
            <div
              block="StyleGuide"
              elem="Fonts"
            >
                <h3>{ __('Fonts') }</h3>
                <div
                  block="StyleGuide"
                  elem="FontsWrapper"
                >
                    <h4 block="StyleGuide" elem="FontsBlock" mods={ { font: 'ffdin-bold' } }>Font FFDIN Bold</h4>
                </div>
                <div
                  block="StyleGuide"
                  elem="FontsWrapper"
                >
                    <h4 block="StyleGuide" elem="FontsBlock" mods={ { font: 'ffdin-regular' } }>Font FFDIN Regular</h4>
                </div>
            </div>
        );
    }

    renderMediaMixins() {
        return (
            <div
              block="StyleGuide"
              elem="Mixins"
            >
                <h3>{ __('Media Mixins') }</h3>
                <div
                  block="StyleGuide"
                  elem="MixinsWrapper"
                >
                    <div
                      block="StyleGuide"
                      elem="MixinItem"
                    >
                        <h4 block="StyleGuide" elem="MixinsBlock">after-mobile()</h4>
                        <h4 block="StyleGuide" elem="MixinsBlock">min-width: 768px</h4>
                    </div>
                    <div
                      block="StyleGuide"
                      elem="MixinItem"
                    >
                        <h4 block="StyleGuide" elem="MixinsBlock">mobile()</h4>
                        <h4 block="StyleGuide" elem="MixinsBlock">max-width: 767px</h4>
                    </div>
                    <div
                      block="StyleGuide"
                      elem="MixinItem"
                    >
                        <h4 block="StyleGuide" elem="MixinsBlock">small-tablet()</h4>
                        <h4 block="StyleGuide" elem="MixinsBlock">min-width: 760px</h4>
                    </div>
                    <div
                      block="StyleGuide"
                      elem="MixinItem"
                    >
                        <h4 block="StyleGuide" elem="MixinsBlock">small-desktop()</h4>
                        <h4 block="StyleGuide" elem="MixinsBlock">min-width: 1025px</h4>
                    </div>
                    <div
                      block="StyleGuide"
                      elem="MixinItem"
                    >
                        <h4 block="StyleGuide" elem="MixinsBlock">small-desktop-down()</h4>
                        <h4 block="StyleGuide" elem="MixinsBlock">max-width: 1024px</h4>
                    </div>
                    <div
                      block="StyleGuide"
                      elem="MixinItem"
                    >
                        <h4 block="StyleGuide" elem="MixinsBlock">lagre-desktop()</h4>
                        <h4 block="StyleGuide" elem="MixinsBlock">min-width: 1181px</h4>
                    </div>
                    <div
                      block="StyleGuide"
                      elem="MixinItem"
                    >
                        <h4 block="StyleGuide" elem="MixinsBlock">large-desktop-down()</h4>
                        <h4 block="StyleGuide" elem="MixinsBlock">max-width: 1180px</h4>
                    </div>
                </div>
            </div>
        );
    }

    renderIconsBlock() {
        return (
            <div
              block="StyleGuide"
              elem="Icons"
            >
                <h3>
                    { __('Icons') }
                    { ' ' }
                    { __('Optional: mods black/white') }
                </h3>
                <div
                  block="StyleGuide"
                  elem="IconsWrapper"
                >
                    <div
                      block="StyleGuide"
                      elem="IconItem"
                    >
                        <h4 block="StyleGuide" elem="IconsBlock">Facebook</h4>
                        <span>block="Icon" elem="Facebook"</span>
                        <div block="Icon" elem="Facebook" />
                    </div>
                    <div
                      block="StyleGuide"
                      elem="IconItem"
                    >
                        <h4 block="StyleGuide" elem="IconsBlock">Instagram</h4>
                        <span>block="Icon" elem="Instagram"</span>
                        <div block="Icon" elem="Instagram" />
                    </div>
                    <div
                      block="StyleGuide"
                      elem="IconItem"
                    >
                        <h4 block="StyleGuide" elem="IconsBlock">Twitter</h4>
                        <span>block="Icon" elem="Twitter"</span>
                        <div block="Icon" elem="Twitter" />
                    </div>
                    <div
                      block="StyleGuide"
                      elem="IconItem"
                    >
                        <h4 block="StyleGuide" elem="IconsBlock">Youtube</h4>
                        <span>block="Icon" elem=`Youtube`</span>
                        <div block="Icon" elem="Youtube" />
                    </div>
                    <div
                      block="StyleGuide"
                      elem="IconItem"
                    >
                        <h4 block="StyleGuide" elem="IconsBlock">ArrowRight</h4>
                        <span>
                            block="Icon" elem="ArrowRight"
                            mods=
                            { '{{ color: "white" }}' }
                            mods=
                            { '{{ color: "black" }}' }
                        </span>
                        <div block="Icon" elem="ArrowRight" />
                        <div block="Icon" elem="ArrowRight" mods={ { color: 'white' } } />
                    </div>
                    <div
                      block="StyleGuide"
                      elem="IconItem"
                    >
                        <h4 block="StyleGuide" elem="IconsBlock">Cart</h4>
                        <span>
                            block="Icon" elem="Cart"
                            mods=
                            { '{{ color: "white" }}' }
                            mods=
                            { '{{ color: "black" }}' }
                        </span>
                        <div block="Icon" elem="Cart" />
                        <div block="Icon" elem="Cart" mods={ { color: 'white' } } />
                    </div>
                    <div
                      block="StyleGuide"
                      elem="IconItem"
                    >
                        <h4 block="StyleGuide" elem="IconsBlock">User</h4>
                        <span>
                            block="Icon" elem="User"
                            mods=
                            { '{{ color: "white" }}' }
                            mods=
                            { '{{ color: "black" }}' }
                        </span>
                        <div block="Icon" elem="User" />
                        <div block="Icon" elem="User" mods={ { color: 'white' } } />
                    </div>
                    <div
                      block="StyleGuide"
                      elem="IconItem"
                    >
                        <h4 block="StyleGuide" elem="IconsBlock">Searchbar</h4>
                        <span>
                            block="Icon" elem="Searchbar"
                            mods=
                            { '{{ color: "white" }}' }
                            mods=
                            { '{{ color: "black" }}' }
                        </span>
                        <div block="Icon" elem="Searchbar" />
                        <div block="Icon" elem="Searchbar" mods={ { color: 'white' } } />
                    </div>
                    <div
                      block="StyleGuide"
                      elem="IconItem"
                    >
                        <h4 block="StyleGuide" elem="IconsBlock">Right</h4>
                        <span>
                            block="Icon" elem="Right"
                            mods=
                            { '{{ color: "white" }}' }
                            mods=
                            { '{{ color: "black" }}' }
                        </span>
                        <div block="Icon" elem="Right" />
                        <div block="Icon" elem="Right" mods={ { color: 'white' } } />
                    </div>
                    <div
                      block="StyleGuide"
                      elem="IconItem"
                    >
                        <h4 block="StyleGuide" elem="IconsBlock">Bottom</h4>
                        <span>
                            block="Icon" elem="Bottom"
                            mods=
                            { '{{ color: "white" }}' }
                            mods=
                            { '{{ color: "black" }}' }
                        </span>
                        <div block="Icon" elem="Bottom" />
                        <div block="Icon" elem="Bottom" mods={ { color: 'white' } } />
                    </div>
                    <div
                      block="StyleGuide"
                      elem="IconItem"
                    >
                        <h4 block="StyleGuide" elem="IconsBlock">Left</h4>
                        <span>
                            block="Icon" elem="Left"
                            mods=
                            { '{{ color: "white" }}' }
                            mods=
                            { '{{ color: "black" }}' }
                        </span>
                        <div block="Icon" elem="Left" />
                        <div block="Icon" elem="Left" mods={ { color: 'white' } } />
                    </div>
                    <div
                      block="StyleGuide"
                      elem="IconItem"
                    >
                        <h4 block="StyleGuide" elem="IconsBlock">Up</h4>
                        <span>
                            block="Icon" elem="Up"
                            mods=
                            { '{{ color: "white" }}' }
                            mods=
                            { '{{ color: "black" }}' }
                        </span>
                        <div block="Icon" elem="Up" />
                        <div block="Icon" elem="Up" mods={ { color: 'white' } } />
                    </div>
                    <div
                      block="StyleGuide"
                      elem="IconItem"
                    >
                        <h4 block="StyleGuide" elem="IconsBlock">Question</h4>
                        <span>
                            block="Icon" elem="Question"
                        </span>
                        <div block="Icon" elem="Question" />
                    </div>
                    <div
                      block="StyleGuide"
                      elem="IconItem"
                    >
                        <h4 block="StyleGuide" elem="IconsBlock">Menu</h4>
                        <span>
                            block="Icon" elem="Menu"
                            mods=
                            { '{{ color: "white" }}' }
                            mods=
                            { '{{ color: "black" }}' }
                        </span>
                        <div block="Icon" elem="Menu" />
                        <div block="Icon" elem="Menu" mods={ { color: 'white' } } />
                    </div>
                    <div
                      block="StyleGuide"
                      elem="IconItem"
                    >
                        <h4 block="StyleGuide" elem="IconsBlock">Close</h4>
                        <span>
                            block="Icon" elem="Close"
                            mods=
                            { '{{ color: "white" }}' }
                            mods=
                            { '{{ color: "black" }}' }
                        </span>
                        <div block="Icon" elem="Close" />
                        <div block="Icon" elem="Close" mods={ { color: 'white' } } />
                    </div>
                    <div
                      block="StyleGuide"
                      elem="IconItem"
                    >
                        <h4 block="StyleGuide" elem="IconsBlock">Zoom</h4>
                        <span>
                            block="Icon" elem="Zoom"
                        </span>
                        <div block="Icon" elem="Zoom" />
                    </div>
                    <div
                      block="StyleGuide"
                      elem="IconItem"
                    >
                        <h4 block="StyleGuide" elem="IconsBlock">ArrowScroll</h4>
                        <span>block="Icon" elem="ArrowScroll"</span>
                        <div block="Icon" elem="ArrowScroll" />
                    </div>
                    <div
                      block="StyleGuide"
                      elem="IconItem"
                    >
                        <h4 block="StyleGuide" elem="IconsBlock">CheckGreen</h4>
                        <span>block="Icon" elem="CheckGreen"</span>
                        <div block="Icon" elem="CheckGreen" />
                    </div>
                    <div
                      block="StyleGuide"
                      elem="IconItem"
                    >
                        <h4 block="StyleGuide" elem="IconsBlock">CheckGreen</h4>
                        <span>block="Icon" elem="Flag"</span>
                        <div block="Icon" elem="Flag" />
                    </div>
                </div>
            </div>
        );
    }

    renderLogosBlock() {
        return (
            <div
              block="StyleGuide"
              elem="Logos"
            >
                <h3>
                    { __('Logos') }
                    { ' ' }
                    { __('Optional: mods black/white') }
                </h3>
                <div
                  block="StyleGuide"
                  elem="LogosWrapper"
                >
                    <div
                      block="StyleGuide"
                      elem="IconItem"
                    >
                        <h4 block="StyleGuide" elem="LogoBlock">Logo</h4>
                        <span>block="Icon" elem="Puma"</span>
                        <div block="Icon" elem="Puma" />
                        <div block="Icon" elem="Puma" mods={ { color: 'black' } } />
                    </div>
                    <div
                      block="StyleGuide"
                      elem="IconItem"
                    >
                        <h4 block="StyleGuide" elem="LogoBlock">Logo With Text</h4>
                        <span>block="Icon" elem="PumaWithText"</span>
                        <div block="Icon" elem="PumaWithText" />
                    </div>
                </div>
            </div>
        );
    }

    renderButtonsBlock() {
        return (
            <div
              block="StyleGuide"
              elem="Buttons"
            >
                <h3>{ __('Buttons') }</h3>
                <div
                  block="StyleGuide"
                  elem="ButtonsWrapper"
                >
                    <div
                      block="StyleGuide"
                      elem="ButtonItem"
                    >
                        <h4 block="StyleGuide" elem="ButtonBlock">Button</h4>
                        <span>
                            <span>block="Button"</span>
                            <span>elem="Primary" (Optional)</span>
                        </span>
                        <button block="Button">Black button</button>
                    </div>
                    <div
                      block="StyleGuide"
                      elem="ButtonItem"
                    >
                        <h4 block="StyleGuide" elem="ButtonBlock">Button White</h4>
                        <span>
                            <span>block="Button"</span>
                            <span>elem="Primary"</span>
                            <span>
                            mods=
                            { '{{ color: "white" }}' }
                            </span>
                        </span>
                        <button block="Button" elem="Primary" mods={ { color: 'white' } }>White button</button>
                    </div>
                    <div
                      block="StyleGuide"
                      elem="ButtonItem"
                    >
                        <h4 block="StyleGuide" elem="ButtonBlock">Button Gray</h4>
                        <span>
                            <span>block="Button"</span>
                            <span>elem="Primary"</span>
                            <span>
                            mods=
                            { '{{ color: "gray" }}' }
                            </span>
                        </span>
                        <button block="Button" elem="Primary" mods={ { color: 'gray' } }>Gray button</button>
                    </div>
                    <div
                      block="StyleGuide"
                      elem="ButtonItem"
                    >
                        <h4 block="StyleGuide" elem="ButtonBlock">Button Add To Cart</h4>
                        <span>
                            <span>block="Button"</span>
                            <span>elem="AddToCart"</span>
                        </span>
                        <button block="Button" elem="AddToCart">Add To Cart</button>
                    </div>
                    <div
                      block="StyleGuide"
                      elem="ButtonItem"
                    >
                        <h4 block="StyleGuide" elem="ButtonBlock">Button Login/Checkout</h4>
                        <span>
                            <span>block="Button"</span>
                            <span>elem="Primary"</span>
                            <span>
                            mods=
                            { '{{ color: "brown" }}' }
                            </span>
                        </span>
                        <button block="Button" elem="Primary" mods={ { color: 'brown' } }>Login</button>
                    </div>
                    <div
                      block="StyleGuide"
                      elem="ButtonItem"
                    >
                        <h4 block="StyleGuide" elem="ButtonBlock">Button Checkout Next Step</h4>
                        <span>
                            <span>block="Button"</span>
                            <span>elem="Checkout"</span>
                            <span>
                                mods=
                                { '{{ withArrow: true }}' }
                                (Optional)
                            </span>
                        </span>
                        <button block="Button" elem="Checkout" mods={ { withArrow: true } }>Next Step: Payment</button>
                    </div>
                </div>
            </div>
        );
    }

    renderLinkBlock() {
        return (
            <div
              block="StyleGuide"
              elem="Links"
            >
                <h3>{ __('Links') }</h3>
                <div
                  block="StyleGuide"
                  elem="LinksWrapper"
                >
                    <div
                      block="StyleGuide"
                      elem="LinkItem"
                      mods={ { background: 'black' } }
                    >
                        <h4 block="StyleGuide" elem="LinkBlock">Menu item link</h4>
                        <span>
                            <span>block="Link"</span>
                            <span>
                                mix=
                                { '{{ block: "Link", elem: "Menu" }}' }
                            </span>
                        </span>
                        <div>
                            <Link
                              block="Link"
                              mix={ { block: 'Link', elem: 'Menu' } }
                              to="/"
                            >
                                { __('Kids') }
                            </Link>
                        </div>
                    </div>
                    <div
                      block="StyleGuide"
                      elem="LinkItem"
                    >
                        <h4 block="StyleGuide" elem="LinkBlock">PDP size chart</h4>
                        <span>
                            <span>block="Link"</span>
                            <span>
                                mix=
                                { '{{ block: "Link", elem: "Chart" }}' }
                            </span>
                        </span>
                        <div>
                            <Link
                              block="Link"
                              mix={ { block: 'Link', elem: 'Chart' } }
                              to="/"
                            >
                                { __('size chart') }
                            </Link>
                        </div>
                    </div>
                    <div
                      block="StyleGuide"
                      elem="LinkItem"
                      mods={ { background: 'black' } }
                    >
                        <h4 block="StyleGuide" elem="LinkBlock">Footer link</h4>
                        <span>
                            <span>block="Link"</span>
                            <span>
                                mix=
                                { '{{ block: "Link", elem: "Footer" }}' }
                            </span>
                        </span>
                        <div>
                            <Link
                              block="Link"
                              mix={ { block: 'Link', elem: 'Footer' } }
                              to="/"
                            >
                                { __('Privacy Policy') }
                            </Link>
                        </div>
                    </div>
                    <div
                      block="StyleGuide"
                      elem="LinkItem"
                    >
                        <h4 block="StyleGuide" elem="LinkBlock">Primary link</h4>
                        <span>
                            <span>block="Link"</span>
                            <span>
                                mix=
                                { '{{ block: "Link", elem: "Primary" }}' }
                            </span>
                        </span>
                        <div>
                            <Link
                              block="Link"
                              mix={ { block: 'Link', elem: 'Primary' } }
                              to="/"
                            >
                                { __('Terms and Conditions') }
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderInputFields() {
        return (
            <div
              block="StyleGuide"
              elem="Inputs"
            >
                <h3>{ __('Inputs') }</h3>
                <div
                  block="StyleGuide"
                  elem="InputsWrapper"
                >
                    <div
                      block="StyleGuide"
                      elem="InputItem"
                    >
                        <h4 block="StyleGuide" elem="InputBlock">Text Inputs</h4>
                        <div block="StyleGuide" elem="InputProps">
                            <span>Props</span>
                            <span>type="text" - required prop</span>
                            <span>placeholder="firstname" - optional prop</span>
                            <span>label="firstname" - optional prop</span>
                            <span>isRequired - optional prop</span>
                        </div>
                        <Field type="text" placeholder="first name" isRequired />
                        <Field type="text" placeholder="last name" isRequired />
                        <Field type="text" placeholder="street address" isRequired />
                        <Field type="text" placeholder="complsex/building (optional)" />
                    </div>
                    <div
                      block="StyleGuide"
                      elem="InputItem"
                    >
                        <h4 block="StyleGuide" elem="InputBlock">Email Inputs</h4>
                        <div block="StyleGuide" elem="InputProps">
                            <span>Props</span>
                            <span>type="email" - required prop</span>
                            <span>placeholder="email" - optional prop</span>
                            <span>label="email" - optional prop</span>
                            <span>isRequired - optional prop</span>
                        </div>
                        <Field type="email" placeholder="email" isRequired />
                    </div>
                    <div
                      block="StyleGuide"
                      elem="InputItem"
                    >
                        <h4 block="StyleGuide" elem="InputBlock">Number Inputs</h4>
                        <div block="StyleGuide" elem="InputProps">
                            <span>Props</span>
                            <span>type="phone" - required prop</span>
                            <span>placeholder="phone number" - optional prop</span>
                            <span>label="phone number" - optional prop</span>
                            <span>isRequired - optional prop</span>
                            <span>showCheckMark - optional prop</span>
                            <span>prefix="+27" - required prop</span>
                            <span>minLength=10 - required prop</span>
                        </div>
                        <Field
                          type="phone"
                          placeholder="phone number"
                          isRequired
                          showCheckMark
                          prefix="+27"
                          minLength={ 10 }
                        />
                    </div>
                    <div
                      block="StyleGuide"
                      elem="InputItem"
                    >
                        <div>
                        <h4 block="StyleGuide" elem="InputBlock">Password Inputs</h4>
                        <div block="StyleGuide" elem="InputProps">
                            <span>Props</span>
                            <span>type="password" - required prop</span>
                            <span>placeholder="password" - optional prop</span>
                            <span>labelPlaceholder="password" - optional prop</span>
                            <span>isRequired - optional prop</span>
                            <span>validation="login" - optional (can be eather login or register)</span>
                        </div>
                        </div>
                        <div>
                        <Field type="password" placeholder="password" isRequired validationType="login" />
                        <Field type="password" placeholder="password" isRequired validationType="register" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderSelectDropdown() {
        return (
          <div
            block="StyleGuide"
            elem="Inputs"
          >
              <h3>{ __('Select') }</h3>
              <div
                block="StyleGuide"
                elem="InputsWrapper"
              >
                  <div
                    block="StyleGuide"
                    elem="InputItem"
                  >
                      <h4 block="StyleGuide" elem="InputBlock">Select Dropdown</h4>
                      <div block="StyleGuide" elem="InputProps">
                          <span>Props</span>
                          <span>type="select" - required prop</span>
                          <span>placeholder="some placeholder" - optional prop</span>
                          <span>labelPlaceholder="some label" - optional prop</span>
                          <span>isRequired - optional prop</span>
                          <span>
                              selectOptions=
                              { '{[ {id: 1, value: 1, label: "one"} ]}' }
                              optional prop
                          </span>
                      </div>
                      <Field
                        type="select"
                        placeholder="this is select placholder"
                        labelPlaceholder="region"
                        isRequired
                        selectOptions={ [
                            {
                                id: 1,
                                value: '1',
                                label: 'some text goes here'
                            },
                            {
                                id: 2,
                                value: '2',
                                label: 'some text goes here'
                            },
                            {
                                id: 3,
                                value: '3',
                                label: 'some text goes here'
                            },
                            {
                                id: 4,
                                value: '4',
                                label: 'some text goes here'
                            },
                            {
                                id: 5,
                                value: '5',
                                label: 'some text goes here'
                            },
                            {
                                id: 6,
                                value: '6',
                                label: 'some text goes here'
                            },
                            {
                                id: 7,
                                value: '7',
                                label: 'some text goes here'
                            },
                            {
                                id: 8,
                                value: '8',
                                label: 'some text goes here'
                            },
                            {
                                id: 9,
                                value: '9',
                                label: 'some text goes here'
                            }
                        ] }
                      />
                  </div>
              </div>
          </div>
        );
    }

    renderCheckboxes() {
        return (
            <div
              block="StyleGuide"
              elem="Inputs"
            >
                <h3>{ __('Checkbox') }</h3>
                <div
                  block="StyleGuide"
                  elem="InputsWrapper"
                >
                    <div
                      block="StyleGuide"
                      elem="InputItem"
                    >
                        <h4 block="StyleGuide" elem="InputBlock">Checkbox</h4>
                        <Field
                          type="checkbox"
                          value="checkbox-1"
                          id="checkbox-1"
                          name="checkbox-1"
                          label="Checkbox 1"
                        />
                        <Field
                          type="checkbox"
                          value="checkbox-2"
                          id="checkbox-2"
                          name="checkbox-2"
                          label="Checkbox 2"
                        />
                    </div>
                </div>
            </div>
        );
    }

    renderRadioButtons() {
        return (
            <div
              block="StyleGuide"
              elem="Inputs"
            >
                <h3>{ __('Radio buttons') }</h3>
                <div
                  block="StyleGuide"
                  elem="InputsWrapper"
                >
                    <div
                      block="StyleGuide"
                      elem="InputItem"
                    >
                        <h4 block="StyleGuide" elem="InputBlock">Radio selected</h4>
                        <Field
                          type="radio"
                          id="radio-1"
                          checked={ 1 }
                          value="1"
                        />
                    </div>
                    <div
                      block="StyleGuide"
                      elem="InputItem"
                    >
                        <h4 block="StyleGuide" elem="InputBlock">Radio unselected</h4>
                        <Field
                          type="radio"
                          id="radio-1"
                          checked={ 0 }
                          value="1"
                        />
                    </div>
                </div>
            </div>
        );
    }

    renderPopUps() {
        const { toggleOverlayByKey, showPopup } = this.props;

        return (
          <div
            block="StyleGuide"
            elem="PopUps"
          >
              <h3>{ __('PopUps') }</h3>
              <div
                block="StyleGuide"
                elem="PopUpsWrapper"
              >
                  <div
                    block="StyleGuide"
                    elem="PopUpItem"
                  >
                      <button
                        block="Button"
                        // eslint-disable-next-line react/jsx-no-bind
                        onClick={ () => {
                            showPopup('This is styleguide pop up');
                            toggleOverlayByKey(STYLEGUIDE_POPUP);
                        } }
                      >
                        Open popup
                      </button>
                      <Popup
                        id={ STYLEGUIDE_POPUP }
                        title="bbb"
                        mix={ { block: 'StyleGuide', elem: 'Popup' } }
                      >
                          <p>Some long text inside of a popup. Pop up with scroll</p>
                          <p>Some long text inside of a popup. Pop up with scroll</p>
                          <p>Some long text inside of a popup. Pop up with scroll</p>
                          <p>Some long text inside of a popup. Pop up with scroll</p>
                          <p>Some long text inside of a popup. Pop up with scroll</p>
                          <p>Some long text inside of a popup. Pop up with scroll</p>
                          <p>Some long text inside of a popup. Pop up with scroll</p>
                          <p>Some long text inside of a popup. Pop up with scroll</p>
                          <p>Some long text inside of a popup. Pop up with scroll</p>
                          <p>Some long text inside of a popup. Pop up with scroll</p>
                          <p>Some long text inside of a popup. Pop up with scroll</p>
                          <p>Some long text inside of a popup. Pop up with scroll</p>
                          <p>Some long text inside of a popup. Pop up with scroll</p>
                          <p>Some long text inside of a popup. Pop up with scroll</p>
                          <p>Some long text inside of a popup. Pop up with scroll</p>
                          <p>Some long text inside of a popup. Pop up with scroll</p>
                          <p>Some long text inside of a popup. Pop up with scroll</p>
                          <p>Some long text inside of a popup. Pop up with scroll</p>
                          <p>Some long text inside of a popup. Pop up with scroll</p>
                          <p>Some long text inside of a popup. Pop up with scroll</p>
                          <p>Some long text inside of a popup. Pop up with scroll</p>
                      </Popup>
                  </div>
              </div>
          </div>
        );
    }

    render() {
        return (
            <div
              block="StyleGuide"
            >
                { this.renderColorsBlock() }
                { this.renderFontsBlock() }
                { this.renderMediaMixins() }
                { this.renderIconsBlock() }
                { this.renderLogosBlock() }
                { this.renderButtonsBlock() }
                { this.renderLinkBlock() }
                { this.renderInputFields() }
                { this.renderSelectDropdown() }
                { this.renderCheckboxes() }
                { this.renderRadioButtons() }
                { this.renderPopUps() }
            </div>
        );
    }
}

export default StyleGuideComponent;
